export const RECOVERY_DELETE_ACCESS_COLLECTION =
  "recoveryDeleteAccessEmails";

export const normalizeRecoveryDeleteEmail = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const isValidRecoveryDeleteEmail = (value) => {
  const email = normalizeRecoveryDeleteEmail(value);
  return Boolean(email && email.includes("@") && !email.includes("/"));
};

export const isRecoveryDeleteAccessOwner = (user) =>
  String((user && user.displayName) || "")
    .trim()
    .toLowerCase() === "admin888";
